<template>
    <div class="button-comp">
      <button :data-toggle="dataToggle"  data-target="#exampleModalLong" class="btn btn--sm btn--text btn--flex" :class="classes" v-if="!hideButton" @click="onClick" :disabled="disabled" :data-dismiss="dataDismiss">
        <slot></slot>
        <div class="btn--text">{{ buttonName }}</div>
      </button>
    </div>
</template>
<script>
export default {
    name: 'Button',
    props: {
       hideButton: Boolean,
       onClick: Function,
       buttonName: String,
       disabled: Boolean,
       classes: String,
       dataToggle: String,
       dataDismiss: String,
    }
}
</script>
<style lang="scss" scoped>
  .btn {
    display: flex;
  }

  .woven-color {
  background: #e00b5b;
  border-radius: 4px;
  .btn--text {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 18px;
    color: #fff;
    width: 100%;
    text-align: center;
  }
}

  .grey {
    background: #EBF0F4;
    border: none;
    box-sizing: border-box;
    box-shadow: 0px 8px 14px rgba(0, 0, 0, 0.05);
    border-radius: 6px;

    .btn--text {
      color: #655D79;
    }
  }

  .woven-border-only {
  background: #fff;
  border: 1px solid #e00b5b;
  svg {
    margin-right: 10px;
  }
  .btn--text {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 18px;
    text-align: center;
    color: #e00b5b;
  }
}
.basic-woven {
  background: #fff;
  svg {
    margin-right: 10px;
  }
  .btn--text {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 18px;
    text-align: center;
    color: #e00b5b;
  }
}
.basic {
  background: #fff;
  border: 1px solid #e00b5b;
  svg {
    margin-right: 10px;
  }
}


  .basic {
    background: #fff;
    border: 1px solid #DFE2E5;

    svg {
      margin-right: 10px;
    }
  }

  .grey {
    background: #EBF0F4;
    justify-content: center;

    .btn--text {
      /*font-family: 'lato-regular';*/
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
      text-align: center;
      color: #655D79;
    }
  }

  .blank {
    background: #fff;

    .btn--text {
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
      letter-spacing: 0.1px;
      color: #121212;
    }
  }

  .basic-borderless {
    background: #fff;
  }

  .pending {
    background: rgba(255, 154, 2, 0.18);
    border-radius: 4px;

    .btn--text {
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 18px;
      color: #FF9A02;
    }
  }

  .failed {
    background: rgba(243, 107, 127, 0.16); 
    border-radius: 4px;

    .btn--text {
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 18px;
      color: #F36B7F;
    }
  }

  .cancelled {
    background: rgba(196, 196, 196, 0.16);
    border-radius: 4px;

    .btn--text {
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 18px;
      color: #121212;
    }
  }

  .danger {
    background: #B1524D;;
    border-radius: 4px;
    .btn--text {
      color: #fff;
    }   
  }

  .completed, .settled {
    background: rgba(96, 205, 167, 0.18);
    border-radius: 4px;

    .btn--text {
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 18px;
      color: #e00b5b;
    }
  }

  .text {
    background: #fff;
    cursor: pointer;
    box-shadow: none;

    .btn--text {
      font-style: normal;
      font-weight: 500;
      font-size: 15px;
      line-height: 18px;
      color: rgba(38, 25, 64, 0.6);
    }
  }

  .primary {
    background: #e00b5b;
    border-radius: 4px;

    .btn--text {
      color: #fff;
      display: flex;
      align-items: center;
    }
  }
</style>